import { EMPTY_LIST } from '../../../constants/common'
import i18n from '../../../i18n'
import { DOCUMENT_USER_ACCESS_ROLE } from '../Document.constants'

export function getUserAccessLabelList(value) {
  if (!value || value.length === 0) {
    return EMPTY_LIST
  }

  return value.map(role => i18n.t(DOCUMENT_USER_ACCESS_ROLE[role]))
}
